import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import {useRecoilValue, useSetRecoilState} from "recoil";
import * as Renders from "../../../component/AdvancedFiltersRenders";
import AdvancedFilter from "../../../component/AdvancedFilter";
import { STATE_ACTIVE_FILTERS } from "../constants/TransactionRecoil";
import {
    ID_FILTER_EXPIRATION_DATE_FROM,
    ID_FILTER_EXPIRATION_DATE_TO,
    ID_FILTER_NETWORK_CODE,
    ID_FILTER_STATUS,
    ID_FILTER_TYPE,
    NETWORK_CODE,
    TRANSACTION_STATUSES, transactionDefaultValues,
    TYPES
} from "../constants/TransactionConstants";
import {addFilter, getFilterValue} from "../../../utils/FilterUtils";
import {ID_FILTER_CUSTOMER} from "../constants/CardConstants";

function TransactionFilters() {
    const { t } = useTranslation("finance", { keyPrefix: "payments.amex.transactions" });
    const filterDefs = useRecoilValue(STATE_ACTIVE_FILTERS);
    const setFilters = useSetRecoilState(STATE_ACTIVE_FILTERS);
    const schema = Yup.object().shape({
        [ID_FILTER_EXPIRATION_DATE_FROM]: Yup.date().nullable().test("testFrom", t('filters.errors.invalid-expiration-date-from'), (value, context) => {
            return !value || !context.parent.expirationDateTo || (value <= context.parent.expirationDateTo);
        }).test('date-range-expiration', t('filters.errors.invalid-expiration-date-from'), function (value) {
            const { dateTo } = this.parent;
            return !value || !dateTo || value <= dateTo;
        }).typeError(t('filters.errors.invalid-expiration-date-from')),
        [ID_FILTER_EXPIRATION_DATE_TO]: Yup.date().nullable().test("testTo", t('filters.errors.invalid-expiration-date-to'), (value, context) => {
            return !value || !context.parent.expirationDateFrom || (value >= context.parent.expirationDateFrom);
        }).test('date-range-expiration', t('filters.errors.invalid-expiration-date-to'), function (value) {
            const { dateFrom } = this.parent;
            return !value || !dateFrom || value >= dateFrom;
        }).typeError(t('filters.errors.invalid-expiration-date-to')),   
    });

    const defaultValues = {      
        [ID_FILTER_TYPE]: getFilterValue(ID_FILTER_TYPE, filterDefs) || "",
        [ID_FILTER_NETWORK_CODE]: getFilterValue(ID_FILTER_NETWORK_CODE, filterDefs) || [],
        [ID_FILTER_STATUS]: getFilterValue(ID_FILTER_STATUS, filterDefs) || [],
        [ID_FILTER_EXPIRATION_DATE_FROM]: getFilterValue(ID_FILTER_EXPIRATION_DATE_FROM, filterDefs) || null,
        [ID_FILTER_EXPIRATION_DATE_TO]: getFilterValue(ID_FILTER_EXPIRATION_DATE_TO, filterDefs) || null,
    };

    const fields = {
        main: {
            [ID_FILTER_TYPE]: Renders.renderSelect(
                ID_FILTER_TYPE,
                t("filters." + ID_FILTER_TYPE),
                TYPES.map((x) => {
                    return { ...x, label: t(x.label) };
                })
            ),
            [ID_FILTER_NETWORK_CODE]: Renders.renderMultiSelect(
                ID_FILTER_NETWORK_CODE,
                t("filters." + ID_FILTER_NETWORK_CODE),
                NETWORK_CODE.map((x) => {
                    return { ...x, label: t(x.label) };
                })
            ),
            [ID_FILTER_STATUS]: Renders.renderMultiSelect(
                ID_FILTER_STATUS,
                t("filters." + ID_FILTER_STATUS),
                TRANSACTION_STATUSES.map((x) => {
                    return { ...x, label: t(x.label) };
                })
            )
        },
        adv: {
            [ID_FILTER_EXPIRATION_DATE_FROM]: Renders.renderDatePickerFrom(
                ID_FILTER_EXPIRATION_DATE_FROM,
                t("filters." + ID_FILTER_EXPIRATION_DATE_FROM)
            ),
            [ID_FILTER_EXPIRATION_DATE_TO]: Renders.rendereDatePickerTo(
                ID_FILTER_EXPIRATION_DATE_TO,
                t("filters." + ID_FILTER_EXPIRATION_DATE_TO)
            )
        }
    };

    const submit = (data: any) => {
        Object.keys(defaultValues)
            .forEach((param) => {
                addFilter(setFilters, param, data[param]);
            });
    };

    const reset = () => {
        setFilters([]);
    };

    return (
        <AdvancedFilter
            schema={schema}
            mainFields={fields.main}
            fields={fields.adv}
            defaultValues={defaultValues}
            onSubmit={submit}
            onReset={reset}
            customDefaultValues={transactionDefaultValues}

        />
    );
}

export default TransactionFilters;
